export const GIFT_WITH_PURCHASE_SCHEMA_VERSION = 1
export const GIFT_WITH_PURCHASE_COLLECTION = 'giftWithPurchase'
export const GIFT_WITH_PURCHASE_DOC_ID = 'config'

export const GIFT_REWARD_GROUP_SAMPLES_ID = 'samples'
export const GIFT_REWARD_GROUP_GIFTS_ID = 'gifts'

export const GIFT_TIER_FROM_0_ID = 'tier_from_0'
export const GIFT_TIER_FROM_3000_ID = 'tier_from_3000'
export const GIFT_TIER_FROM_5000_ID = 'tier_from_5000'
export const GIFT_TIER_FROM_10000_ID = 'tier_from_10000'

/** Початкова конфігурація механіки (незбережені значення форми, якщо документа ще немає). */
export const GIFT_WITH_PURCHASE_DEFAULTS = {
  schemaVersion: GIFT_WITH_PURCHASE_SCHEMA_VERSION,
  applyToOutlet: false,
  rewardGroups: [
    { id: GIFT_REWARD_GROUP_SAMPLES_ID, name: 'Семпли', sortOrder: 0 },
    { id: GIFT_REWARD_GROUP_GIFTS_ID, name: 'Подарунки', sortOrder: 1 },
  ],
  tiers: [
    {
      id: GIFT_TIER_FROM_0_ID,
      minAmount: 0,
      sortOrder: 0,
      quotas: { [GIFT_REWARD_GROUP_SAMPLES_ID]: 1, [GIFT_REWARD_GROUP_GIFTS_ID]: 0 },
    },
    {
      id: GIFT_TIER_FROM_3000_ID,
      minAmount: 3000,
      sortOrder: 1,
      quotas: { [GIFT_REWARD_GROUP_SAMPLES_ID]: 2, [GIFT_REWARD_GROUP_GIFTS_ID]: 0 },
    },
    {
      id: GIFT_TIER_FROM_5000_ID,
      minAmount: 5000,
      sortOrder: 2,
      quotas: { [GIFT_REWARD_GROUP_SAMPLES_ID]: 3, [GIFT_REWARD_GROUP_GIFTS_ID]: 0 },
    },
    {
      id: GIFT_TIER_FROM_10000_ID,
      minAmount: 10000,
      sortOrder: 3,
      quotas: { [GIFT_REWARD_GROUP_SAMPLES_ID]: 3, [GIFT_REWARD_GROUP_GIFTS_ID]: 1 },
    },
  ],
  packaging: {
    categorySelection: null,
    freeFromTierId: GIFT_TIER_FROM_3000_ID,
  },
}
